export default "__VITE_ASSET__4sMWyarD__"